"use client";

import Link from "next/link";

export default function NotFound() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "2rem",
        background: "linear-gradient(135deg, #f8faf8 0%, #e8f5e9 100%)",
        fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          fontSize: "8rem",
          fontWeight: 800,
          lineHeight: 1,
          background: "linear-gradient(135deg, #2e7d32, #66bb6a)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "0.5rem",
        }}
      >
        404
      </div>
      <h1
        style={{
          fontSize: "1.75rem",
          fontWeight: 600,
          color: "#1b5e20",
          marginBottom: "0.75rem",
        }}
      >
        Page Not Found
      </h1>
      <p
        style={{
          fontSize: "1.05rem",
          color: "#555",
          maxWidth: "440px",
          lineHeight: 1.6,
          marginBottom: "2rem",
        }}
      >
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
        Try heading back to the homepage.
      </p>
      <div style={{ display: "flex", gap: "1rem" }}>
        <Link
          href="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.75rem 1.75rem",
            borderRadius: "8px",
            background: "linear-gradient(135deg, #2e7d32, #43a047)",
            color: "#fff",
            fontWeight: 600,
            fontSize: "0.95rem",
            textDecoration: "none",
            transition: "transform 0.15s ease, box-shadow 0.15s ease",
            boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
          }}
        >
          ← Go Home
        </Link>
        <button
          onClick={() => typeof window !== "undefined" && window.history.back()}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.75rem 1.75rem",
            borderRadius: "8px",
            background: "transparent",
            color: "#2e7d32",
            fontWeight: 600,
            fontSize: "0.95rem",
            border: "2px solid #2e7d32",
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
        >
          Go Back
        </button>
      </div>
    </main>
  );
}
